export default __webpack_public_path__ + "static/media/ikitoursviajes.34d9c68c.png";